import { TranslationObject } from '../i18n/translation';

const namespace = 'myorganization.psa';
const translations: TranslationObject = {
  title: {
    id: `${namespace}.title`,
    nb: 'Min organisasjon',
    en: 'My organization',
  },
  subtitle: {
    id: `${namespace}.subtitle`,
    nb: 'Her ser du en liste over alle kolleger som har en brukerrolle i Arbeidslivsportalen, samt en visning for avdelingsinndeling til ditt praksissted og hvilke praksisavtaler din organisasjon er tilknyttet.',
    en: 'All your colleagues with access to Arbeidslivsportalen, as well as the the organization hierarchy and the practice place agreements your organization is associated with.',
  },
  newuser: {
    id: `${namespace}.newuser`,
    nb: 'Inviter ny bruker',
    en: 'Invite new user',
  },
  name: {
    id: `${namespace}.name`,
    nb: 'Medarbeiders navn',
    en: 'Name',
  },
  role: {
    id: `${namespace}.role`,
    nb: 'Rolle',
    en: 'Role',
  },
  email: {
    id: `${namespace}.email`,
    nb: 'Epost',
    en: 'Email',
  },
  affiliation: {
    id: `${namespace}.affiliation`,
    nb: 'Tilhørighet',
    en: 'Affiliation',
  },
  action: {
    id: `${namespace}.action`,
    nb: 'Handling',
    en: 'Action',
  },
  deleteUser: {
    id: `${namespace}.deleteUser`,
    nb: 'Slett bruker',
    en: 'Delete user',
  },
  confirmDeleteTitle: {
    id: `${namespace}.confirmDeleteTitle`,
    nb: 'Bekreft sletting av bruker',
    en: 'Confirm user deletion',
  },
  confirmDeleteUser: {
    id: `${namespace}.confirmDeleteContent`,
    nb: 'Er du sikker på at du vil slette {name} som bruker?',
    en: 'Are you sure you want to delete {name} as a user?',
  },
  confirmDeleteUserWithActivities1: {
    id: `${namespace}.confirmDeleteUserWithActivities1`,
    nb: 'Er du sikker på at du vil slette {name} som bruker?',
    en: 'Are you sure you want to delete {name} as a user?',
  },
  confirmDeleteUserWithActivities2: {
    id: `${namespace}.confirmDeleteUserWithActivities2`,
    nb: 'Brukeren er registrert på {numActivities} fremtidige aktiviteter og vil bli fjernet fra disse.',
    en: 'This user is regiserted on {numActivities} future activities and will be removed from these.',
  },
  deleteSucceeded: {
    id: `${namespace}.deleteSucceeded`,
    nb: 'Bruker slettet',
    en: 'User successfully deleted',
  },
  avdelingsoversiktInfo: {
    id: `${namespace}.avdelinsoversiktInfo`,
    nb: 'Her ser du listen over avdelinger og plasser som er inkludert i praksis ved studiesteder',
    en: 'This is the list of departments and places that are included in work placements at the educational institutions',
  },
  avdelingStatusActive: {
    id: `${namespace}.avdelingStatusActive`,
    nb: 'Aktiv',
    en: 'Active',
  },
  colleagues: {
    id: `${namespace}.colleagues`,
    nb: 'Kollega',
    en: 'Colleague',
  },
  departments: {
    id: `${namespace}.departments`,
    nb: 'Avdelingsoversikt',
    en: 'Departments',
  },
  workPlaceProfile: {
    id: `${namespace}.colleague`,
    nb: 'Stedprofil',
    en: 'Work place profile',
  },
  status: {
    id: `${namespace}.status`,
    nb: 'Status',
    en: 'Status',
  },
  agreements: {
    id: `${namespace}.agreements`,
    nb: 'Avtaler med studiesteder',
    en: 'Agreements with institutions',
  },
};

export default translations;
